var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01863 1.15666C8.62811 0.766138 7.99494 0.766138 7.60442 1.15666L1.24046 7.52062C0.849931 7.91115 0.849931 8.54431 1.24046 8.93484C1.63098 9.32536 2.26414 9.32536 2.65467 8.93484L8.31152 3.27798L13.9684 8.93484C14.3589 9.32536 14.9921 9.32536 15.3826 8.93484C15.7731 8.54431 15.7731 7.91115 15.3826 7.52062L9.01863 1.15666ZM9.31152 21.5762L9.31152 1.86377L7.31152 1.86377L7.31152 21.5762L9.31152 21.5762Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/Arrow 2.ef183577d371a344d46343016bf6be4e.svg";
export { ForwardRef as ReactComponent };